import React from 'react'
import { Chip } from '@material-ui/core'
import clsx from 'clsx'

import constants from 'constants/index'
import useStyles from './styles'

const ChipProgressStatus = ({ progressStatus, isInactive = false, id }) => {
  const classes = useStyles()
  const {
    PENDING_PROGRESS_STATUS,
    IN_PROGRESS_PROGRESS_STATUS,
    COMPLETED_PROGRESS_STATUS,
    OVERDUE_PROGRESS_STATUS,
    PROGRESS_STATUSES_LABEL,
    INACTIVE_LABEL,
  } = constants.companySuppliers

  if (isInactive) {
    return (
      <Chip
        id={id}
        className={clsx(classes.root, classes.inactive)}
        label={INACTIVE_LABEL}
        size="small"
      />
    )
  }

  return (
    <Chip
      id={id}
      className={clsx(classes.root, {
        [classes.pending]: progressStatus === PENDING_PROGRESS_STATUS,
        [classes.inProgress]: progressStatus === IN_PROGRESS_PROGRESS_STATUS,
        [classes.completed]: progressStatus === COMPLETED_PROGRESS_STATUS,
        [classes.overdue]: progressStatus === OVERDUE_PROGRESS_STATUS,
      })}
      label={PROGRESS_STATUSES_LABEL[progressStatus]}
      size="small"
    />
  )
}

export default ChipProgressStatus
